import { motion } from "framer-motion";
import { ArrowRight, Images, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import heroImg from "@/assets/hero-solar.png";

export function Hero() {
  return (
    <section
      id="top"
      className="relative min-h-screen flex items-center overflow-hidden bg-background text-foreground"
    >
      <div className="absolute inset-0 grid-pattern opacity-60" />
      <motion.div
        className="absolute inset-y-0 -left-24 -right-24 opacity-90 will-change-transform"
        style={{
          backgroundImage: `url(${heroImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          maskImage: "linear-gradient(to left, black 85%, transparent)",
          WebkitMaskImage: "linear-gradient(to left, black 85%, transparent)",
        }}
        animate={{
          x: [-72, 0, 0, -72, -72],
          opacity: [0.92, 0.92, 0, 0, 0.92],
        }}
        transition={{
          duration: 12,
          repeat: Infinity,
          ease: "linear",
          times: [0, 0.72, 0.82, 0.92, 1],
        }}
      />
      {/* soft fade behind copy for readability */}
      <div className="absolute inset-0 bg-linear-to-r from-background/95 via-background/75 to-background/15" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20 w-full">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl"
        >
          <h1 className="mt-6 text-5xl sm:text-6xl lg:text-7xl font-bold leading-[1.05] tracking-tight">
            Solar power, <span className="text-primary">engineered for you.</span>
          </h1>

          <p className="mt-6 text-lg text-muted-foreground max-w-xl leading-relaxed">
            Green Volt LTD designs, installs and maintains premium solar PV systems built on Deye
            hybrid inverters and Sunwave lithium batteries — backed by certified electrical
            expertise across Mauritius.
          </p>

          <div className="mt-9 flex flex-wrap gap-3">
            <Button asChild size="lg" className="h-12 px-6 text-base shadow-glow">
              <a href="#quotation">
                Request a Quotation
                <ArrowRight className="ml-2 w-4 h-4" />
              </a>
            </Button>
            <Button asChild size="lg" variant="outline" className="h-12 px-6 text-base">
              <a href="#gallery">
                <Images className="mr-2 w-4 h-4" />
                View Installations
              </a>
            </Button>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-6 max-w-md">
            {[
              { k: "500kW+", v: "Installations" },
              { k: "30 yrs", v: "Panel Warranty" },
              { k: "5000+", v: "Tons of CO₂ saved" },
            ].map((s) => (
              <div key={s.v}>
                <div className="text-2xl sm:text-3xl font-display font-bold text-primary">
                  {s.k}
                </div>
                <div className="text-xs text-muted-foreground mt-1">{s.v}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
